import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';

import { TranslateModule } from "@ngx-translate/core";
import { POSLineProductsModalComponentGeneric } from "./pos-line-products-modal.component";
import {MatDialogModule} from '@angular/material/dialog';
import {ProductsCarouselModule_Generic} from '@signature-it/ngx-catalogue/components/products-carousel';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        MatDialogModule,
        ProductsCarouselModule_Generic
    ],
    exports: [POSLineProductsModalComponentGeneric],
    declarations: [POSLineProductsModalComponentGeneric]
})
export class POSLineProductsModalModuleGeneric {}
